<template>
    <div class="role_warp">
      <!-- 头部工具栏 -->
      <div class="role_heard_tool">
        <el-button
          type="success"
          size="mini"
          @click="getDate()"
          >刷新</el-button
        >
        <el-button
          type="primary"
          class="edit-button"
          size="mini"
          style="margin-left: 10px"
          @click="select()"
          >筛选</el-button
        >
      </div>
      <div class="head_search">
        <div class="item_warp">
          <label style="margin: 0 10px">用户</label>
          <el-input 
            v-model="uid"
            placeholder="请输入uid"
            style="width: 120px"
            size="mini"
            clearable
          />
        </div>
        <div class="item_warp">
          <label style="margin: 0 10px">hashId</label>
          <el-input
            v-model="hashId"
            placeholder="请输入hashId"
            style="width: 120px"
            size="mini"
            clearable
          />
        </div>
        <div class="item_warp">
          <label style="margin: 0 10px">转出地址</label>
          <el-input
            v-model="fromAddress"
            placeholder="请输入转出地址"
            style="width: 120px"
            size="mini"
            clearable
          />
        </div>
        <div class="item_warp">
          <label style="margin: 0 10px">转入地址</label>
          <el-input
            v-model="toAddress"
            placeholder="请输入转入地址"
            style="width: 120px"
            size="mini"
            clearable
          />
        </div>
        <div class="item_warp">
          <label style="margin: 0 10px">时间</label>
          <el-date-picker
            v-model="dataTime"
            type="daterange"
            value-format="yyyy-MM-dd"
            style="margin-right: 10px"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="head_search">
        <div class="item_warp">
          <div style="color: red">总归集金额：{{ totalRechargeCunt || 0 }}</div>
        </div>
      </div>
      <!-- 表单 -->
      <el-table
        ref="gridTable"
        v-loading="loading"
        :data="tableData"
        tooltip-effect="dark"
        :stripe="true"
        :border="true"
        height="calc(100vh - 240px )"
        style="width: 961px"
        size="mini"
      >
        <el-table-column prop="memberUid" label="用户" width="100" />
        <el-table-column prop="pol" label="金额" width="100" />
        <el-table-column prop="fromAddress" label="转出地址" width="130" />
        <el-table-column prop="toAddress" label="转入地址" width="130" />
        <el-table-column prop="hashId" label="hashid" width="200" />
        <el-table-column prop="adminUsername" label="操作管理员" width="130" />
        <el-table-column prop="createDate" label="创建时间" width="170" />
      </el-table>
      <!-- 分页 -->
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="pageNum"
        :limit.sync="pageSize"
        @pagination="getList"
      />
    </div>
  </template>
  <script>
  import Pagination from "@/components/Pagination"; // 引入分页器
  import VueUeditorWrap from "vue-ueditor-wrap"; // ES6 Module
  import validEmail from "@/utils/validate"; // 引入邮箱验证方法
  import md5 from "js-md5"; // 引入Md5加密
  
  export default {
    name: "Management",
    components: { Pagination, VueUeditorWrap },
    data() {
      return {
        tableData: [], // 展示的表单信息
        total: 0, // 总数
        pageNum: 1, // 页码值
        pageSize: 20, // 页大小
        loading: false, // 表格加
        uid: "",
        hashId: "",
        fromAddress: "",
        toAddress: "",
        ip: "",
        yifangUsername: "",
        dataTime: ["", ""],
        totalRechargeCunt: 0,
      };
    },
    mounted() {
      this.getDate();
    },
    methods: {
      // 筛选
      select() {
        this.pageNum = 1;
        this.getList();
        this.totalRecharge();
      },
      getDate() {
        this.getList();
        this.totalRecharge();
      },
      totalRecharge() {
        var params = {
          pageNumber: this.pageNum,
          pageSize: this.pageSize,
          uid: this.uid,
          hashId: this.hashId,
          fromAddress: this.fromAddress,
          toAddress: this.toAddress,
          startDate: this.dataTime[0],
          endDate: this.dataTime[1],
        };
        this.loading = true;
        this.$refs.gridTable.bodyWrapper.scrollTop = 0;
        this.$api.Polygon
          .totalAmountTrx(params)
          .then((res) => {
            this.totalRechargeCunt = res;
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.loading = false;
          });
      },
      // 获取表单信息
      getList() {
        var params = {
          pageNumber: this.pageNum,
          pageSize: this.pageSize,
          uid: this.uid,
          hashId: this.hashId,
          fromAddress: this.fromAddress,
          toAddress: this.toAddress,
          startDate: this.dataTime[0],
          endDate: this.dataTime[1],
        };
        this.loading = true;
        this.$refs.gridTable.bodyWrapper.scrollTop = 0;
        this.$api.Polygon
          .tronscanCollectionListTrx(params)
          .then((res) => {
            this.tableData = res.records;
            this.total = res.total;
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.loading = false;
          });
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  .role_warp {
    width: 100%;
    overflow: hidden;
    font-size: 14px;
    padding: 10px;
    box-sizing: border-box;
    .role_heard_tool {
      margin-bottom: 10px;
    }
    .edit_titile {
      .dialog_input {
        // width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 70%;
        span {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          margin-right: 20px;
        }
        .el-input {
          flex: 3;
        }
      }
    }
    .tree {
      margin-top: 25px;
      display: flex;
      justify-content: space-around;
    }
    .authority_info {
      margin-top: 25px;
    }
  }
  .el-input {
    width: 70%;
  }
  </style>
  